<div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" role="switch" id="{{ id }}"
         [formControl]="control"
         [(ngModel)]="inputValue"
         (input)="onInputChange($event)">
  <label class="form-check-label" for="{{ id }}">{{ label }}</label>
</div>
